<template>
    <div class="modal medium-modal">
		<div class="inner">
			<h2 v-if="getAdministratorFlag">{{ listDetail.manufacturer_map_policy_id  ? 'Edit' : 'Add' }} a Manufacturer Map Holiday</h2>
			<h2 v-else>Manufacturer Map Holiday</h2>

			<div class="content">

                <div class="title">{{ listDetailLocal.description }}</div>

                <div style="margin: 0 0 0.5em 0;">
                    <span :class="['pointer', 'far', listDetailLocal.all_products ? 'fa-check-square' : 'fa-square']" @click="toggleProduct()"></span> <label>This holiday applies to all manufacturer's products</label>
                </div>
                <div class="two-columns" style="margin: 0 0 0.5em 0;">
					<div>
	                    <span :class="['pointer', 'far', !listDetailLocal.all_products ? 'fa-check-square' : 'fa-square']" @click="toggleProduct()"></span> <label>This holiday applies to a specific product</label>
					</div>
					<div v-if="getAdministratorFlag && !listDetailLocal.all_products" class="button small neutral" @click="doSearchProduct()">{{ listDetailLocal.product_id ? 'Change' : 'Find a' }} Product</div>
                </div>

                <div v-if="listDetailLocal.product" style="margin: 1em;">
					{{ listDetailLocal.product }}
					<div class="two-columns">
						<div><label>UPC</label> {{ listDetailLocal.upc }}</div>
						<div><label>MAP</label> {{ listDetailLocal.map }}</div>
					</div>
				</div>

				<div class="three-columns">
					<div>
						<label>Start</label>
						<input type="date" v-model="listDetailLocal.start_date" :disabled="!getAdministratorFlag" />
					</div>
					<div>
						<label>End</label>
						<input type="date" v-model="listDetailLocal.end_date" :disabled="!getAdministratorFlag" />
					</div>
					<div>
						<label>Note</label>
						<input type="text" v-model="listDetailLocal.notes" :disabled="!getAdministratorFlag" />
					</div>
				</div>
				<div class="message-overlay" v-if="saveMessage">
					<p v-html="saveMessage"></p>
					<div class="empty"><i :class="['fa', saveSuccess ? 'fa-check' : 'fa-ban']" /></div>
				</div>
				<div class="message-overlay" v-if="confirmDelete">
					<p>Are you sure you want to delete this manufacturer MAP policy?</p>
					<div style="font-size: 0.8em;">
						<div class="button cancel spaced" @click="cancelItem()">Cancel</div>
						<div class="button delete spaced" @click="deleteItem()">Yes, Delete</div>
					</div>
				</div>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="cancelItem()">Cancel</div>
				<div v-if="getAdministratorFlag && listDetailLocal.manufacturer_map_policy_id && listDetailLocal.product_id" :class="['button', saving ? 'disabled' : 'neutral', 'spaced']" @click="copyItem()">Copy</div>
				<div v-if="getAdministratorFlag && listDetailLocal.manufacturer_map_policy_id" :class="['button', saving ? 'disabled' : 'neutral', 'spaced']" @click="confirmDelete = true">Delete</div>
				<div v-if="getAdministratorFlag" :class="['button', 'spaced', saving || (!listDetailLocal.all_products && !listDetailLocal.product_id) ? 'disabled' : 'action']" @click="saveItem()">Save MAP Policy</div>
			</div>
		</div>
    </div>
</template>
<script>
import NumberInput from '@/components/NumberInput.vue'
export default {
    name: 'map-poliy-detail',
    props: {
        listDetail: {
            type: Object,
			default() {
            	return {}
        	}
		},
		manufacturerId: {
			type: [Number, String],
			default() {
				return ''
			}
		},
		productId: {
			type: [Number, String],
			default() {
				return ''
			}
		}
    },
    components: {
		'number-input': NumberInput
    },
	data() {
		return {
			saving: false,
			saveMessage: '',
			saveSuccess: false,
			confirmDelete: false,
			listDetailLocal: {},
            searchText: ''
		}
	},
    created() {
		if (this.productId || this.manufacturerId) {
			this.getDetail()
		} else {
			this.listDetailLocal = JSON.parse(JSON.stringify(this.listDetail))
			this.listDetailLocal.all_products = !this.listDetail.product_id
		}
    },
	methods: {
		getDetail() {
			this.listDetailLocal = {}
			this.apiCall({ destination: 'get_item_manufacturer_map_policy', data: { product_id: this.productId, manufacturer_id: this.manufacturerId } }).then(obj => {
				if (obj.status == 'success') {
					if (obj.manufacturer_map_policy) {
						this.listDetailLocal = obj.manufacturer_map_policy
					} else {
						if (this.getAdministratorFlag) {
							this.listDetailLocal = {
								manufacturer_id: this.manufacturerId,
								product_id: this.productId,
								all_products: 1
							}
						} else {
							this.saveMessage = 'No MAP holiday set for this ' + (this.productId ? 'product' : 'manufactuer') + '.'
						}
					}
				} else {
					this.saveMessage = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		toggleProduct() {
			if (!this.getAdministratorFlag) {
				return
			}
			this.listDetailLocal.all_products = !this.listDetailLocal.all_products
		},
		doSearchProduct(which) {
            this.$emit('searchProduct', { manufacturer_id: this.listDetailLocal.manufacturer_id, description: this.listDetailLocal.description } ) // parent updateRequired = false
		},
		saveItem(copying) {
			if (this.saving) { return }
			if (!this.listDetailLocal.all_products && !this.listDetailLocal.product_id) { 
				this.saveMessage = 'Check all products OR select a specific product to save.'
				setTimeout(() => { this.saveMessage = '' }, 2500);
				return
			}
			this.saveSuccess = false
			this.saving = true
			this.saveMessage = (copying ? 'Copying' : 'Saving') + ' manufacturer MAP policy...'
			this.apiCall({ destination: 'save_item_manufacturer_map_policy', data: this.listDetailLocal }).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					this.saveSuccess = true
					this.saveMessage = 'Manufacturer MAP policy ' + (copying ? 'copied!' : 'saved!')
					setTimeout(() => {
						if (!copying) {
							this.$emit('backToList', true) // parent updateRequired = true
						}
						this.saveMessage = ''
						this.listDetailLocal.manufacturer_map_policy_id = obj.manufacturer_map_policy_id
					}, 2000);
				} else {
					this.saveMessage = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		copyItem() {
			this.listDetailLocal.manufacturer_map_policy_id = ''
			this.saveItem(true)
		},
		deleteItem() {
			if (this.saving) { return }
			this.saving = true
			this.confirmDelete = false
			this.saveMessage = 'Deleting manufacturer MAP policy...'
			this.apiCall({ destination: 'save_item_manufacturer_map_policy', data: { manufacturer_map_policy_id: this.listDetailLocal.manufacturer_map_policy_id, delete: true } }).then(obj => {
				if (obj.status == 'success') {
					this.saveSuccess = true
					this.saveMessage = 'Manufacturer MAP policy deleted!'
					setTimeout(() => {
						this.$emit('backToList', true) // parent updateRequired = true
						this.saveMessage = ''
					}, 2000);
				} else {
					this.saveMessage = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
        cancelItem() {
            this.saveMessage = ''
            this.$emit('backToList', false) // parent updateRequired = false
        }
    }
}
</script>
